var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Adminpay24DepositDetails',{attrs:{"deposit":_vm.deposit,"busy":_vm.busy,"error":_vm.error},on:{"check":_vm.load,"attach-slip":function($event){_vm.slipOpened = true},"restart":function($event){return _vm.$emit('restart')}}})}
var staticRenderFns = []

export { render, staticRenderFns }